import dao from '../../dao';
import {EventBus} from '../../services/event-bus.js';

// Initial State
const state = {
    parts: [],
    currentLevelParts: [],
    currentLevelDrawings: [],
    selectedPart: null,
    selectedHotspot: null,
    selectedLocale: 'en-US',
    selectedDrawing: null,
    drawingShown: false,
    hotspotsData: null,
    gridColumns: [],
    gridRows: [],
    drawerOpen: true,
    searchVisible: false,
    locales: [],
    features: [],
    panAndZoomOnHotspotSelection: true,
    searchResults: [],
    breadCrumbs: [],
    drawingMap: {},
    uxd: {alt: "", url: ""},
    token: "",
    baseurl: "",
    single: null,
    searchLoading: false,
    searchText : '',
    isFirstDrawing : true,
    isLastDrawing : true,
    partScroll: {},
    basket : [],
    orderFunc : null,
    orderColumnLabel : '',
    orderColumnValue : '',
    hotspotFuncs: [],
    specificFunc : -1,
    isPrinting : false
}

const getters = {
    isPartSelected: state => state.selectedPart !== null,
    isDrawerOpen: state => state.drawerOpen,
    isLeftPaneVisible: state => state.selectedPart !== null,
    isPartListVisible: state => !state.searchVisible && (state.selectedPart === null || (state.selectedPart !== null && state.selectedPart.type === 'group')),
    isDrawingListVisible: state => !state.searchVisible && state.selectedPart !== null && state.selectedPart.type === "project" && !state.drawingShown,
    isDrawingVisible: state => state.selectedDrawing !== null && state.drawingShown,
    isDrawingSelected: state => state.selectedDrawing !== null,
    parentPartId: state => state.selectedPart !== null ? state.selectedPart.parent : -1,
    selectedPartId: state => state.selectedPart !== null ? state.selectedPart.id : -1,
    selectedDrawingId: state => state.selectedDrawing !== null ? state.selectedDrawing.id : -1,
    selectedDrawingSrc: state => state.selectedDrawing !== null ? state.selectedDrawing.src : '',
    selectedHotspotId: state => state.selectedHotspot !== undefined && state.selectedHotspot !== null ? state.selectedHotspot.id : -1,
    parentDrawingId: state => state.selectedDrawing !== null ? state.selectedDrawing.parent : -1,
    hasParentDrawing: state => state.selectedDrawing !== null && state.selectedDrawing.parent !== -1
};

const actions = {
    async getPubTree({commit, getters}) {
        let parts = await dao.getPubTree(state.selectedLocale);
        let currentLevelParts = [];
        let showRev = state.uxd.showrevisionnumber;
        for (let partIndex in parts) {
            let part = parts[partIndex];
            part.partIndex = partIndex;
            if (getters.selectedPartId === part.parent) {
                currentLevelParts.push(part)
            }
            if (part.type === 'project') {
                part.thumbUrl = dao.BASE_URL + 'getThumbnail.php?token=' + dao.TOKEN + '&id=prj' + part.data.id + '&size=full'
            } else if (part.type === 'group') {
                part.thumbUrl = dao.BASE_URL + 'getThumbnail.php?token=' + dao.TOKEN + '&id=grp' + part.data.id + '&size=full'
            }
            if(showRev == "never")
              part.showRev = false;
            else if(showRev == "always")
              part.showRev = part.type == "project";
            else
              part.showRev = [...new Set(parts.filter(x => x.type == "project" && x.data.orig == part.data.orig).map(x => x.data.revision))].length > 1;
        }

        state.token = dao.TOKEN;
        state.baseurl = dao.BASE_URL;
        state.single = dao.SINGLE;
        commit('updateParts', parts);
        commit('updateCurrentLevelParts', currentLevelParts);
        // If entire scope, store for future re-scoping
        let scope = parseInt(window.sessionStorage.getItem('scope') || '-1');
        if(scope == -1)
          window.sessionStorage.setItem('entirescope', JSON.stringify(parts));

    },
    async search({commit}, term) {
      let searchResults = [];
      if (term !== '' && term != null) {
        state.searchLoading = true;
        state.searchResults = [];
        let userScope = -1;
        if(document.getElementById("top-toolbar-search-withinscope").checked) {
          if(state.selectedPart != null)
            userScope = state.selectedPart.id;
        }
        let searchInfo = await dao.search(term, userScope);
        state.searchLoading = false;
        searchResults = searchInfo;
      }
      commit('updateSearchResults', searchResults);
    },
    async getUXD({commit, state}) {
        let uxd = await dao.getUXD(state.selectedLocale)
        commit('updateUXD', uxd)
    },
    async getFeatures({commit}) {
      let features = await dao.getFeatures();
      commit('updateFeatures', features);
    },
    async getLocales({commit, dispatch}) {
        let locales = await dao.getLocales();
        commit('updateLocales', locales);
        dispatch('restoreLocaleState');
    },
    async cleanupCookies({state}) {
      if(state.uxd.ordercontext != "_script")
        window.sessionStorage.removeItem("orderscriptcalls");
      if(state.uxd.quotecontext != "_script")
        window.sessionStorage.removeItem("quotescriptcalls");
    },
    selectLocale({commit, dispatch}, locale) {
        commit('setSelectedLocale', locale);
        dispatch('saveLocaleState');
        location.reload();
    },
    selectPart({commit, state, dispatch}, partToSelect) {
        commit('setShowDrawing', false);
        let currentLevelParts = state.parts.filter((pp) => pp.parent === partToSelect.id);
        let currentLevelDrawings = partToSelect.data.drawings ?
            partToSelect.data.drawings.filter((dd) => dd.parent === -1) : [];
        commit('setSelectedDrawing', null);
        commit('updateCurrentLevelDrawings', currentLevelDrawings);
        commit('updateCurrentLevelParts', currentLevelParts)
        commit('setSelectedPart', partToSelect)
        dispatch('savePartState');
    },
    goToPreviousDrawing({dispatch}) {
      let drw = state.selectedPart.data.drawings.find(x => x.id == state.selectedDrawing.id);
      let navDrw = state.selectedPart.data.drawings.find(x => x.parent == drw.parent && x.sequence == drw.sequence - 1);
      if(navDrw != null) {
        dispatch('showDrawingById', navDrw.id);
      }
    },
    goToNextDrawing({dispatch}) {
      let drw = state.selectedPart.data.drawings.find(x => x.id == state.selectedDrawing.id);
      let navDrw = state.selectedPart.data.drawings.find(x => x.parent == drw.parent && x.sequence == drw.sequence + 1);
      if(navDrw != null) {
        dispatch('showDrawingById', navDrw.id);
      }
    },
    goToSubDrawings({dispatch}) {
      dispatch('selectDrawingById', state.selectedDrawing.id);
    },
    async selectPartOrRootDrawingById({dispatch}, partId) {
        await loadDrawingTreeByPartId(partId);
        await dispatch('selectPartById', partId);
    },
    levelUp({commit, state, getters, dispatch}) {
      if(state.searchVisible) {
        dispatch('navigateAfterSearch', null);
      } else {
        if (getters.isDrawingSelected) {
            commit('setShowDrawing', false);
            commit('setSelectedHotspot', null);
            dispatch('selectParentDrawing');
        } else if (state.selectedPart != null) {
            dispatch('selectParentPart');
        }
        dispatch('updateBreadCrumbs');
      }
    },
    selectParentDrawing({commit, state, getters, dispatch}) {
        if (getters.hasParentDrawing) {
            let parentDrawing = state.selectedPart
                .data
                .drawings
                .find(drw => drw.id === getters.parentDrawingId);
            let currentLevelDrawings = state.selectedPart.data.drawings ?
                state.selectedPart.data.drawings.filter((dd) => dd.parent === parentDrawing.id) : [];
            commit('updateCurrentLevelDrawings', currentLevelDrawings);
            commit('setSelectedDrawing', parentDrawing);
            state.selectedDrawingId = parentDrawing.id;
            dispatch('selectDrawingById', parentDrawing.id);
        } else {
            commit('setSelectedDrawing', null);
            dispatch('selectPartById', state.selectedPart.id);
        }
    },
    selectParentPart({commit, state, getters, dispatch}) {
        let parent = null;
        if (getters.parentPartId !== -1) {
            parent = state.parts.find(pp => pp.id === getters.parentPartId)
        }
        let currentLevelParts = state.parts.filter((pp) => pp.parent === getters.parentPartId);
        commit('updateCurrentLevelParts', currentLevelParts);
        commit('setSelectedPart', parent);
        dispatch('selectPartById', getters.parentPartId);
    },
    async goToRoot({commit, dispatch}) {
        commit('setSelectedDrawing', null);
        commit('setSelectedPart', null);
        commit('updateBreadCrumbs', []);
        commit('setShowDrawing', false);
        await dispatch('selectParentPart');
    },
    async showDrawing({commit, state, dispatch}, drawingToSelect) {
        stopThumbnailLoading()
        let hotspotsData = null
        if (drawingToSelect) {
            let result = await dao.getDrawing(drawingToSelect.id);
            drawingToSelect.src = result;
            hotspotsData = await dao.getHotspots(drawingToSelect.id, state.selectedLocale);
            if(hotspotsData.hotspots == "")
              hotspotsData.hotspots = [];
        }
        commit("setSelectedDrawing", drawingToSelect);
        commit("setHotspotsData", hotspotsData);
        commit("setShowDrawing", true);
        dispatch("saveDrawingState");
        let drw = state.selectedPart.data.drawings.find(x => x.id == state.selectedDrawing.id);
        state.isLastDrawing = state.selectedPart.data.drawings.find(x => x.parent == drw.parent && x.sequence == drw.sequence + 1) == null;
        state.isFirstDrawing = state.selectedPart.data.drawings.find(x => x.parent == drw.parent && x.sequence == drw.sequence - 1) == null;
        state.hasSubDrawings = state.selectedPart.data.drawings.find(x => x.parent == state.selectedDrawing.id) != null;
        state.subDrawingsCount = state.selectedPart.data.drawings.filter(x => x.parent == state.selectedDrawing.id).length;

    },
    async showDrawingById({state, dispatch}, id) {
        stopThumbnailLoading();
        let drawingToShow = state.drawingMap[id];
        if (drawingToShow !== undefined) {
            await dispatch("showDrawing", drawingToShow);
            await dispatch("updateBreadCrumbs");
        }
    },
    async selectPartById({state, dispatch}, partId) {
        let part = state.parts.find(pp => pp.id.toString() === partId.toString());
        if (part !== undefined) {
            let result = await dao.getDrawingTreeByPartIdOrProjectId(state.selectedLocale, partId, part.data.id);
            let drawings = result.tree;
            MergeDrawingTreeToPubTree(drawings, partId, result.extlinks);
            await dispatch("selectPart", part)
            await dispatch("updateBreadCrumbs")
        }
    },
    async updateBreadCrumbs({commit, getters, state}){
        let partCrumbs = [];
        let breadCrumbs = [];
        if(getters.isPartSelected) {
            let part = state.selectedPart;
            while (part && part.parent && part.parent !== -1) {
                partCrumbs.push({
                    name: part.data.name,
                    link: "/selectpartorrootdrawing/" + part.id
                });
                part = state.parts.find(pp => pp.id === part.parent)
            }
            partCrumbs.reverse();
            if(part.parent === -1) {
                partCrumbs.unshift({
                    name: part.data.name,
                    link: "/selectpartorrootdrawing/" + part.id
                });
            }
            if (getters.isDrawingSelected) {
                let drawing =  state.selectedDrawing;
                let isLeaf = true;
                while (drawing && drawing.parent && drawing.parent !== -1) {
                    breadCrumbs.unshift(
                        { name: drawing.name, link: !isLeaf ? "/selectdrawing/" + drawing.id : ""});
                    drawing = state.drawingMap[drawing.parent];
                    isLeaf = false;
                }
                breadCrumbs.unshift({name: drawing.name, link: !isLeaf  ? "/selectdrawing/" + drawing.id  : ""});
            }
        }
        commit('updateBreadCrumbs', partCrumbs.concat(breadCrumbs));
    },
    async selectDrawing({commit, state, dispatch}, drawingToSelect) {
        let hotspotsData = null;
        let currentLevelDrawings = [];
        let parentPart = {};
        if (drawingToSelect !== null) {
            let result = await dao.getDrawing(drawingToSelect.id);
            drawingToSelect.src = result;
            parentPart = state.parts[drawingToSelect.partIndex];
            commit('setSelectedPart', parentPart);
            hotspotsData = await dao.getHotspots(drawingToSelect.id, state.selectedLocale);
            if(hotspotsData.hotspots == "")
              hotspotsData.hotspots = [];
            currentLevelDrawings = parentPart.data.drawings ?
                parentPart.data.drawings.filter((dd) => dd.parent === drawingToSelect.id) : [];
        }
        commit('updateCurrentLevelParts', []);
        commit('updateCurrentLevelDrawings', currentLevelDrawings);
        commit('setSelectedDrawing', drawingToSelect);
        commit('setHotspotsData', hotspotsData);
        commit('setShowDrawing', false);
        dispatch('saveDrawingState');
        dispatch('updateBreadCrumbs');

        if(state.partScroll[parentPart.id] != null && state.partScroll[parentPart.id] > 0) {
          let list = document.getElementsByClassName('left-pane');
          if(list.length > 0) {
            setTimeout(function() {
              list[0].scrollTop = state.partScroll[parentPart.id];
            }, 250);
          }
        }

    },
    async selectDrawingById({state, dispatch}, id) {
        let drawingToSelect = state.drawingMap[id]
        if (drawingToSelect !== undefined) {
            await dispatch("selectDrawing", drawingToSelect)
        }
    },
    toggleDrawer({commit, state}) {
        commit('setDrawerOpen', !state.drawerOpen)
    },
    openDrawer({commit}) {
        commit('setDrawerOpen', true)
    },
    updateDrawerOpen({commit}, newVal) {
        commit('setDrawerOpen', newVal)
    },
    hideDrawer({commit}) {
        commit('setDrawerOpen', false)
    },
    async showHotspotByDrawingAndHotspotId({dispatch, state}, obj) {
      // eslint-disable-next-line no-console
      if (obj.drawingId !== undefined && obj.hotspotId !== undefined) {
          await dispatch("showDrawingById", obj.drawingId)
          stopThumbnailLoading();
          setTimeout(function() {
            dispatch("selectHotspot", {hotspotId: parseInt(obj.hotspotId), specificFunc : -1});
            let item = document.getElementById('hsit' + obj.hotspotId);
            if(item) {
              let prevItem = item.previousSibling;
              if(prevItem)
                prevItem.scrollIntoView();
              else
                document.querySelector(".parts-grid-wrapper").scroll({top:0, behavior:'smooth'});
            }
          }, state.uxd.navigationdelay)
        }
    },
    selectHotspot({commit, state, dispatch}, obj) {
      let hotspotId = obj.hotspotId;
      state.specificFunc = obj.specificFunc;
      // eslint-disable-next-line no-console
      let clickedHS = null;
      if (hotspotId !== null && hotspotId !== undefined) {
          clickedHS = state.hotspotsData.hotspots.find((hs) => hs.id === hotspotId)
          if (clickedHS !== undefined) {
              if (clickedHS.twin !== -1) {
                  hotspotId = clickedHS.twin;
                  clickedHS = state.hotspotsData.hotspots.find((hs) => hs.id === hotspotId);
              }
              if((state.uxd.thumbnavtosubassynoarticle == "true" &&
                  clickedHS.func[0].article.length == "" &&
                  clickedHS.func[0].link != -1) || 
                  (state.uxd.thumbnavtosubassyonlylinks == "true" &&
                    state.selectedDrawing.funccount == state.selectedDrawing.linkcount
                  ))
                {
                    dispatch("showDrawingById", clickedHS.func[0].link);
              }
          } else {
              // eslint-disable-next-line no-console
              // console.log('no hotspot of id', hotSpotId)
          }
      }
      dispatch('animateHotspot', hotspotId);
      commit('setSelectedHotspot', clickedHS);
      dispatch('saveHotspotState');
    },
    animateHotspot({state}, hotspotId) {
      if(state.uxd.animationtemplate != "") {
        document.querySelectorAll(".pcgAnimation").forEach(el2 => { el2.parentNode.removeChild(el2); });
        let primary = document.getElementById("hs" + hotspotId);
        if(primary != null) {
          if(primary.getAttribute("data-twin") != "-1") primary = document.getElementById("hs" + primary.getAttribute("data-twin"));
          let els = [primary];
          let primaryId = primary.id.substr(2);
          document.querySelectorAll(".pcg_hotspot").forEach(hs => { if(hs.getAttribute("data-twin") == primaryId) els.push(hs)});
          for(let el of els) {
            let cd = JSON.parse(atob(el.getAttribute("data-ref")));
            let animation = state.uxd.animationtemplate
                            .replaceAll('{cx}', cd[0] + cd[2] / 2)
                            .replaceAll('{cy}', cd[1] + cd[3] / 2)
                            .replaceAll('{r}', cd[2] < cd[3] ? cd[3] : cd[2])
                            .replaceAll('{x}', cd[0])
                            .replaceAll('{y}', cd[1])
                            .replaceAll('{w}', cd[2])
                            .replaceAll('{h}', cd[3]);
            let hasLinear = true;
            while(hasLinear) {
              hasLinear = false;
              let p1 = animation.indexOf('{linear');
              if(p1 != -1) {
                let p2 = animation.indexOf('}', p1);
                if(p2 != -1) {
                  let split = animation.substr(p1 + 1, p2 - p1 - 1).split(',');
                  if(split.length == 4) {
                    animation = animation.substr(0, p1) + (parseFloat(split[1]) * parseFloat(split[2]) + parseFloat(split[3])).toString() + animation.substr(p2 + 1);
                    hasLinear = true;
                  }
                }
              }
            }
            let svgAni = document.createElementNS("http://www.w3.org/2000/svg", "g");
            svgAni.innerHTML = animation;
            svgAni.setAttribute("class", "pcgAnimation");
            el.parentNode.parentNode.insertBefore(svgAni, el.parentNode);
          }
        }
      }
    },
    savePartState({getters}) {
      window.localStorage.setItem('partId', getters.selectedPartId)
      window.localStorage.setItem('drawingId', -1)
    },
    saveDrawingState({state, getters}) {
        window.localStorage.setItem('drawingId', getters.selectedDrawingId)
        window.localStorage.setItem('drawingView', state.drawingShown ? 'exploded' : 'tree')
    },
    saveHotspotState({getters}) {
        if (getters.selectedHotspotId && getters.selectedHotspotId !== -1) {
            window.localStorage.setItem('hotspotId', getters.selectedHotspotId)
        }
    },
    saveTreeState({state}) {
        let expState = state.selectedPart.data.drawings.filter(x => x.isExpanded).map(x => x.id).join(',');
        window.localStorage.setItem('treeExpansion', expState);
    },
    savePartScroll({state}) {
      state.partScroll[state.selectedPart.id] = document.getElementsByClassName('left-pane')[0].scrollTop;
    },
    clearPartScroll({state}) {
      state.partScroll[state.selectedPart.id] = null;
    },
    expandOrCollapseAll({dispatch, state}) {
        // Expand or collapse all
        let expPossible = state.selectedPart.data.drawings.some(x => x.hasChildren && !x.isExpanded)
        state.selectedPart.data.drawings.filter(x => x.hasChildren).forEach(function (d) {
            d.isExpanded = expPossible
        });
        dispatch('saveTreeState')
    },
    saveLocaleState({state}) {
        window.localStorage.setItem('locale', state.selectedLocale)
    },
    restoreLocaleState() {
        let langcodes = state.locales.map(x => x.languagecode);
        let locale = window.localStorage.getItem('locale');
        if (langcodes.includes(locale)) {
            state.selectedLocale = locale;
        } else {
            state.selectedLocale = state.locales.length == 0 ? 'en-US' : state.locales[0].languagecode;
        }
    },
    async processTaskMessage({state}, taskJSON) {
      state.dummy = false;
      window.sessionStorage.removeItem('taskSearch');
      window.sessionStorage.removeItem('taskOpenByDrawingName');
      try {
        let task = JSON.parse(taskJSON);
        if(task.cmd == "opendrawingid") {
          window.localStorage.setItem('drawingId', task.id);
          window.localStorage.setItem('drawingView', 'exploded');
          postToParentWindow({task : "openLayer"});
        } else if(task.cmd == "resetordercalls") {
          window.sessionStorage.removeItem('orderscriptcalls');
        } else if(task.cmd == "resetquotecalls") {
            window.sessionStorage.removeItem('quotescriptcalls');
        } else if(task.cmd == "resetscope") {
            window.sessionStorage.removeItem('scope');
        } else if(task.cmd == "openreleaseid") {
          window.sessionStorage.setItem('scope', task.strict ? task.id : -1);
          window.localStorage.setItem('partId', task.id);
          window.localStorage.removeItem("drawingId");
          window.localStorage.removeItem("drawingPage");
          postToParentWindow({task : "openLayer"});
        } else if(task.cmd == "opendrawingname") {
          window.sessionStorage.setItem('taskOpenByDrawingName', taskJSON);
          postToParentWindow({task : "openLayer"});
        } else if(task.cmd == "openreleasename") {
          let entireparts = JSON.parse(window.sessionStorage.getItem('entirescope') || '[]');
          let findPrj;
          if(task.fuzzy && task.casesens)
            findPrj = entireparts.find(x => x.data.name.includes(task.name));
          else if(task.fuzzy && !task.casesens)
            findPrj = entireparts.find(x => x.data.name.toLowerCase().includes(task.name.toLowerCase()));
          else if(!task.fuzzy && task.casesens)
            findPrj = entireparts.find(x => x.data.name == task.name);
          else if(!task.fuzzy && !task.casesens)
            findPrj = entireparts.find(x => x.data.name.toLowerCase() == task.name.toLowerCase());
          let scope = task.strict ? (findPrj ? findPrj.id : -9999) : -1;
          let partId = (scope == -9999 || findPrj == null) ? null : findPrj.id;
          window.sessionStorage.setItem('scope', scope);
          window.localStorage.setItem('partId', partId);
          window.localStorage.removeItem('drawingId');
          window.localStorage.removeItem('drawingView');
          window.localStorage.removeItem('hotspotId');
          postToParentWindow({task : "openLayer"});
        }
        else if(task.cmd == "openmetadata") {
          let partCandidates = JSON.parse(window.sessionStorage.getItem('entirescope') || '[]');
          partCandidates = partCandidates.filter(x => x.data.meta.length > 0);
          for(let pc of partCandidates) {
            for(let md of pc.data.meta) {
              md.range = md.value.includes("~");
              if(md.range) {
                let split = md.value.split("~");
                md.isNum = !isNaN(split[0]) && !isNaN(split[1]);
                if(md.isNum) {
                  md.value1 = parseInt(split[0]);
                  md.value2 = parseInt(split[1]);
                } else {
                  md.value1 = split[0];
                  md.value2 = split[1];
                }
              }
            }
          }

          for (const [key, value] of Object.entries(task.metafilters)) {
            let isNum = !isNaN(value);
            partCandidates = partCandidates.filter(x => x.data.meta.some(y => y.key == key &&
                ((!y.range && y.value == value) ||
                  (y.range &&(
                      (y.isNum && isNum && parseInt(value) >= y.value1 && parseInt(value) <= y.value2) ||
                      ((!y.isNum || !isNum) && value >= y.value1 && value <= y.value2))))));
          }

          if(partCandidates.length > 0) {
            let partId = partCandidates[0].id;
            if(partCandidates[0].type == "project") {
              if(parseInt(task.pageno || "0") >= 0) {
                let pageNo = parseInt(task.pageno);
                await loadDrawingTreeByPartId(partId);
                let part = state.parts.find(x => x.id == partId && x.type == "project");
                if(pageNo >= 0 && pageNo <= part.data.drawings.length) {
                  window.sessionStorage.setItem('scope', -1);
                  window.localStorage.setItem('partId', partId);
                  window.localStorage.removeItem('hotspotId');
                  if(pageNo == 0) {
                    window.localStorage.removeItem('drawingId');
                    window.localStorage.removeItem('drawingView');
                  } else {
                    window.localStorage.setItem('drawingId', part.data.drawings[pageNo - 1].id);
                    window.localStorage.setItem('drawingView', 'exploded');
                  }
                }
              }
            } else {
              // Found Meta Data is a group
              window.sessionStorage.setItem('scope', -1);
              window.localStorage.setItem('partId', partId);
              window.localStorage.removeItem('hotspotId');
              window.localStorage.removeItem('drawingId');
              window.localStorage.removeItem('drawingView');
            }
          }
          postToParentWindow({task : "openLayer"});
        } else if(task.cmd == "filterlayerbymetadata") {
          sessionStorage.setItem("metadata", JSON.stringify(task.metadata));
          this.getPubTree();
        } else if(task.cmd == "clearlayermetadatafilter") {
          sessionStorage.removeItem("metadata");
          this.getPubTree();
        } else if(task.cmd == "setcookie") {
          window.sessionStorage.setItem('uc_' + task.name, task.value);
        } else if(task.cmd == "deletecookie") {
          window.sessionStorage.removeItem('uc_' + task.name);
        } else if(task.cmd == "deleteallcookies") {
          Object.keys(window.sessionStorage).filter(x => x.startsWith('uc_')).forEach(key => {
            window.sessionStorage.removeItem(key);
          });
        }
        else if(task.cmd == "showcookie") {
          // eslint-disable-next-line no-console
          console.log(window.sessionStorage.getItem('uc_' + task.name));
        } else if(task.cmd == "getcookie") {
          let value = window.sessionStorage.getItem('uc_' + task.name);
          postToParentWindow(JSON.stringify({task : "cookie", name : task.name, value : value}));
        } else if(task.cmd == "search") {
          window.sessionStorage.setItem('taskSearch', task.term);
        }
      } catch(ex) {
        //
      }
    },
    async restoreViewState({state, dispatch}) {
        let drawingId;
        let drawingView;
        let apiSearchTerm;
        if(window.sessionStorage.getItem('taskSearch')) {
          apiSearchTerm = window.sessionStorage.getItem('taskSearch');
          window.sessionStorage.removeItem('taskSearch');
          window.localStorage.removeItem('drawingId');
          window.localStorage.removeItem('drawingView');
          window.localStorage.removeItem('partId');
          await dispatch('search', apiSearchTerm);
        }
        if(window.sessionStorage.getItem('taskOpenByDrawingName')) {
          let task = JSON.parse(window.sessionStorage.getItem('taskOpenByDrawingName'));
          window.sessionStorage.removeItem('taskOpenByDrawingName');
          await loadDrawingTreeByDrawingName(task.name, task.casesens, task.fuzzy);
          let findDrw;
          if(task.fuzzy && task.casesens)
            findDrw = Object.values(state.drawingMap).find(x => x.name.includes(task.name));
          else if(task.fuzzy && !task.casesens)
            findDrw = Object.values(state.drawingMap).find(x => x.name.toLowerCase().includes(task.name.toLowerCase()));
          else if(!task.fuzzy && task.casesens)
            findDrw = Object.values(state.drawingMap).find(x => x.name == task.name);
          else if(!task.fuzzy && !task.casesens)
            findDrw = Object.values(state.drawingMap).find(x => x.name.toLowerCase() == task.name.toLowerCase());
          if(findDrw) {
            drawingId = findDrw.id;
            drawingView = 'exploded';
          }
        }
        drawingId = drawingId || window.localStorage.getItem('drawingId');
        drawingView = drawingView || window.localStorage.getItem('drawingView');
        if (drawingId == null) drawingId = -1;
        if (drawingView == null) drawingView = 'tree';

        let hotspotId = window.localStorage.getItem('hotspotId');

        if(drawingId == -1) {

          let partId = window.localStorage.getItem('partId');
          if(partId == null) partId = -1;
          await dispatch("selectPartOrRootDrawingById", partId);

        } else {
          if(state.drawingMap[drawingId] == null)
            await loadDrawingTreeByDrawingId(drawingId);

          let drawingToShow = state.drawingMap[drawingId];
          if (drawingToShow == null) return;
          let part = state.parts[drawingToShow.partIndex];
          if (part == null) return;
          await dispatch("selectPartOrRootDrawingById", part.id);

          // eslint-disable-next-line no-unused-vars
          if(!hotspotId) {
              if(drawingView == 'tree') {
                await dispatch('selectDrawingById', drawingId);
              } else {
                await dispatch('showDrawingById', drawingId);
              }
          } else {
              await dispatch('showHotspotByDrawingAndHotspotId', { drawingId: drawingId, hotspotId: hotspotId});
          }
        }
        if(apiSearchTerm)
          document.getElementById("layerSearchBox").value = apiSearchTerm;

    },
    async restoreExpansionState({state}) {
        let expState = window.localStorage.getItem('treeExpansion');
        if (expState === null || expState === '') return;
        if (state.selectedPart === null) return;
        if (state.selectedPart.data.drawings == null) return;
        state.selectedPart.data.drawings.forEach(function (drw) {
            drw.isExpanded = expState.includes(drw.id);
        })
    },
    async navigateAfterSearch({dispatch}, searchResult) {
      state.searchVisible = false;
      document.getElementsByClassName("theme-searchinput")[0].value = '';
      if (searchResult == null) return;
      if (searchResult.t == 'p' || searchResult.t == 'g') {
        await dispatch("selectPartOrRootDrawingById", searchResult.rid);
      } else {
        await loadDrawingTreeByDrawingId(searchResult.did);
        let drawingToShow = state.drawingMap[searchResult.did];
        if (drawingToShow == null) return;
        let part = state.parts[drawingToShow.partIndex];
        if (part == null) return;
        await dispatch("selectPartOrRootDrawingById", part.id);
        if (searchResult.t == 'hf') {
          dispatch('showHotspotByDrawingAndHotspotId', { drawingId: searchResult.did, hotspotId: searchResult.hid});
        } else if (searchResult.t == 'd') {
          await dispatch('showDrawingById', searchResult.did);
        }
      }
    },
    closeLayer() {
      if(state.uxd.emptyorderbasket)
        window.sessionStorage.removeItem("orderscriptcalls");
      if(state.uxd.emptyquotebasket)
        window.sessionStorage.removeItem("quotescriptcalls");
      postToParentWindow('close_please');
    },
    notifyLayerLoaded() {
      postToParentWindow('layerLoaded');
    },
    registerOrderClick(args, oem) {
        dao.registerOrderClick(oem)
    },
    registerQuoteClick(args, oem) {
        dao.registerQuoteClick(oem)
    },
    updateCheckedHotspots() {
      // Update drawing with checkmarks on hotspots for which the script has already been triggered
      if(state.uxd.ordercontext == "_script" || state.uxd.quotecontext == "_script") {
        let checked = JSON.parse(window.sessionStorage.getItem("orderscriptcalls") || "[]").concat(JSON.parse(window.sessionStorage.getItem("quotescriptcalls") || "[]"));
        document.querySelectorAll(".hotspotCheckmark").forEach(function(el) {
          let func = el.getAttribute("data-funcs").split(",").map(x => parseInt(x));
          let anyChecked = checked.filter(x => func.includes(x)).length > 0;
          el.setAttribute("visibility", anyChecked ? "visible" : "hidden");
        });
      } else {
        document.querySelectorAll(".hotspotCheckmark").forEach(function(el) {
          el.setAttribute("visibility", "hidden");
        });
      }
    },
    prepareEmail({state}) {
      if(state.basket.length == 0) return;
      let ih = '';
      for(let bskItem of state.basket) {
        ih += 'Type: ' + (bskItem.linktype == 'Q' ? 'Request for quote' : 'Order') + '\n';
        for(let bskData of bskItem.data) {
          if(bskData.key == "{drawing}") {
            ih += 'Drawing: ' + document.querySelector(".breadcrumb").textContent + '\n';
          } else {
            ih += bskData.key + ': ' + bskData.value + '\n';
          }
        }
        ih += '\n';
      }
      invokeMailClient(state.uxd.orderemailto, state.uxd.orderemailcc, state.uxd.orderemailsubject, ih);
    },
    addToCart({dispatch}, func) {
      // eslint-disable-next-line no-console
      let url = func.shoplink || "";
      let unURL = func.unshoplink || "";
      let linktype = func.linktype;
      let oem = func.oem;
      let id = func.id;
      let cookie = linktype === 'O' ? 'orderscriptcalls' : 'quotescriptcalls';
      let osc = JSON.parse(sessionStorage.getItem(cookie) || "[]");
      let reqParams = [];
      if(linktype === 'O') {
        if(osc.includes(id) && unURL.trim() != '') {
          if(state.uxd.unorderrequestmethod != "GET")
            reqParams = JSON.parse(state.uxd.unorderrequestheaderparams);
        } else {
          if(state.uxd.orderrequestmethod != "GET")
            reqParams = JSON.parse(state.uxd.orderrequestheaderparams);
        }
      }
      if(linktype === 'Q' && state.uxd.quoterequestmethod != "GET")
        reqParams = JSON.parse(state.uxd.quoterequestheaderparams);

      // Resolve {cookie:cookie_name} placeholder
      if (url.includes('{cookie:')) {
        url = replaceCookiePlaceholder(url);
      }
      if (unURL.includes('{cookie:')) {
        unURL = replaceCookiePlaceholder(unURL);
      }

      // Check for first user placeholder
      if (url.includes('{user:')) {

        let p1 = url.indexOf('{user:')
        let p2 = url.indexOf('}', p1);
        if(p2 > p1 && p1 > -1) {
          if(state.orderColumnValue == '') {
            // It is not a return from the order dialog box, but a first time show
            dispatch('prepareOpenOrderDialog', {cookie: cookie, placeholder: url.substr(p1 + 6, p2 - p1 - 6), func: func});
            return;
          } else {
            // User value is set --> Replace in URL
            url = url.substr(0, p1) + state.orderColumnValue + url.substr(p2 + 1);
          }
        }
      }     // end of url.includes(user)

      // Replace POST/DELETE params contains {user:...} or {cookie:...}
      for(let rp of reqParams) {
        if(rp[1].startsWith("{user:") && rp[1].endsWith("}")) {
          if(state.orderColumnValue == '') {
            // It is not a return from the order dialog box, but a first time show
            dispatch('prepareOpenOrderDialog', {cookie: cookie, placeholder: rp[1].substr(6, rp[1].length - 7), func: func});
            return;
          } else {
            // User value is set --> Replace in Request Parameters
            rp[1] = state.orderColumnValue;
          }
        } else if(rp[1].startsWith("{cookie:") && rp[1].endsWith("}")) {
          // Found a cookie placeholder in the POST
          let name = rp[1].substr(8, rp[1].length - 9);
          rp[1] = window.sessionStorage.getItem('uc_' + name) ?? '';
        } else if(rp[1].startsWith("{") && rp[1].endsWith("}")) {
          let name = rp[1].substr(1, rp[1].length - 2).toLowerCase();
          if(name == "article")
            rp[1] = func.article;
          else if(name == "oem")
            rp[1] = func.oem;
        }
      }


      let context = linktype === 'O' ? state.uxd.ordercontext : state.uxd.quotecontext
      let clickclose = linktype === 'O' ? (state.uxd.ordercloselayer === 'true') : (state.uxd.quotecloselayer === 'true')
      if (context == '_script')
      {
        // First check if already set in cookies
        if(osc.includes(id)) {
          if(unURL.trim() != '') {
            let reqMethod = state.uxd.unorderrequestmethod;
            let request = new XMLHttpRequest();
            if(reqMethod == "GET") {
              request.open("GET", unURL ,true);
              request.send();
            } else {
              let wrap = URLWrap({ url : unURL, method : reqMethod, calltype : "U", domain : state.uxd.domainid, reqparams : reqParams });
              request.open("GET", "https://api.spareparts.live/v1/layerrequest.php?q=" + wrap, true);
              request.send();
            }
            osc = osc.filter(x => x != id);
          }
        } else {
          let reqMethod = linktype === 'O' ? state.uxd.orderrequestmethod : state.uxd.quoterequestmethod;
          let request = new XMLHttpRequest();
          if(reqMethod == "GET") {
            request.open("GET", url ,true);
            request.send();
          } else {
            let wrap = URLWrap({ url : url, method : reqMethod, calltype : linktype, domain : state.uxd.domainid, reqparams : reqParams });
            request.open("GET", "https://api.spareparts.live/v1/layerrequest.php?q=" + wrap, true);
            request.send();
          }
          osc.push(id);
        }
        sessionStorage.setItem(cookie, JSON.stringify(osc));
        dispatch('updateCheckedHotspots');
        EventBus.$emit('refresh-drawing', true);
      }
      else if(context == "_email")
      {
          if(osc.includes(id)) {
            osc = osc.filter(x => x != id);
            state.basket = state.basket.filter(x => x.id != id);
          } else {
            osc.push(id);
            let emailData = [];
            let colDesc = state.hotspotsData.columns;

            for(let hs of state.hotspotsData.hotspots) {
              let func = hs.func.find(x => x.id == id);
              if(func != null) {

                for(let col of state.uxd.orderemaildetails.split(' ')) {
                  if(col == "article")
                    emailData.push({"key" : colDesc[col], "value" : func.article});
                  else if(col == "pos")
                    emailData.push({"key" : colDesc[col], "value" : hs.pos});
                  else {
                    let hsInfo = func.details.find(x => x.column == col);
                    if(hsInfo != null)
                      emailData.push({"key" : colDesc[col], "value" : hsInfo.value});
                    else {
                      let nonFoundKey = colDesc[col] || col;
                      emailData.push({"key" : nonFoundKey, "value" : nonFoundKey == "quantity" || nonFoundKey == "qty" ? "1" : ""});
                    }
                  }
                }
                break;
              }
            }
            state.basket.push({"id" : id, "type" : linktype, "data" : emailData});
          }
          sessionStorage.setItem(cookie, JSON.stringify(osc));
          dispatch('updateCheckedHotspots');
          EventBus.$emit('refresh-drawing', true);

          window.dispatchEvent(new CustomEvent('email_cart_icon_count_changed', {
            detail: {
              itemcount: JSON.parse(sessionStorage.getItem("orderscriptcalls") || "[]").length + JSON.parse(sessionStorage.getItem("quotescriptcalls") || "[]").length
            }
          }));
      }
      else
      {
        if(state.uxd.emptyorderbasket)
          sessionStorage.removeItem("orderscriptcalls");
        if(state.uxd.emptyquotebasket)
          sessionStorage.removeItem("quotescriptcalls");
        window.open(url, context).focus();
        if (linktype === 'O')
        {
          dispatch('registerOrderClick', oem);
        } else {
          dispatch('registerQuoteClick', oem);
        }
        if (clickclose) {
          dispatch('closeLayer');
        }
      }
    },
    prepareOpenOrderDialog(args, config) {
      
      let cookie = config.cookie;
      let placeholder = config.placeholder;
      let func = config.func;

      if(!JSON.parse(sessionStorage.getItem(cookie) || "[]").includes(func.id)) {
      // It is not already ordered
      let split = placeholder.split(":");
      let columnId = split[0];
        state.orderFunc = func;    // Store for future use
        let dataItem = func.details.find(x => x.column == columnId);
        let defaultValue = split.length > 1 ? split[1] : "1";
        if(dataItem) {
          state.orderColumnLabel = dataItem.displayName;
          defaultValue = String(dataItem.value).trim().length > 0 ? String(dataItem.value).trim() : defaultValue;
        } else {
          state.orderColumnLabel = columnId;
          state.orderColumnValue = defaultValue;
        }
        state.orderColumnValue = defaultValue;


        EventBus.$emit('open-order-dialog', true);
        return true;
      }
      return false;
    },
    async printCurrentDrawing() {
      if(state.isPrinting) return;
      state.isPrinting = true;
      if(state.features.createpdfapi) {
        let result = await dao.printDrawingAPI(state.selectedDrawing.id, state.selectedLocale);
        state.isPrinting = false;
        if(result.status == 'ok') {
          window.open(result.link, "pdf");
        }
      }
    }

}

const mutations = {
    updateSearchResults(state, searchRes) {
        state.searchResults = searchRes
        state.searchVisible = true
    },
    setSelectedLocale(state, newLocale) {
        state.selectedLocale = newLocale
    },
    updateParts(state, parts) {
        state.parts = parts
    },
    updateCurrentLevelParts(state, currentLevelParts) {
        state.currentLevelParts = currentLevelParts
    },
    updateCurrentLevelDrawings(state, currentLevelDrawings) {
        state.currentLevelDrawings = currentLevelDrawings
    },
    updateBreadCrumbs(state, newBreadCrumbs) {
        state.breadCrumbs = newBreadCrumbs
    },
    updateDrawingMap(state, drwMap) {
        state.drawingMap = drwMap
    },
    updateUXD(state, uxd) {
        state.uxd = uxd
    },
    updateFeatures(state, features) {
        state.features = features;
    },
    updateLocales(state, locales) {
        state.locales = locales;
    },
    setSelectedPart(state, partToSelect) {
        state.selectedPart = partToSelect
    },
    setSelectedDrawing(state, drawingToSelect) {
        state.selectedDrawing = drawingToSelect
    },
    expandAncestorDrawings(state, drw) {
        while (drw.parent !== -1) {
            let parent = state.drawingMap[drw.parent]
            parent.isExpanded = true
            drw = parent
        }
    },
    setShowDrawing(state, newVal) {
      state.drawingShown = newVal;
    },
    updatePanAndZoomOnHotspotSelection(state, newVal) {
        state.panAndZoomOnHotspotSelection = newVal
    },
    setSelectedHotspot(state, hotspot) {
      if (hotspot != null) {
        for (let cfi in hotspot.func) {
          let curFunc = hotspot.func[cfi]
          let detailItemIndex = 0;
          for (let dti in curFunc.details) {
            let dt = curFunc.details[dti];
            dt.index = detailItemIndex;
            dt.displayName = (state.hotspotsData.columns !== null &&
            state.hotspotsData.columns.hasOwnProperty(dt.column)
                ? state.hotspotsData.columns[dt.column] : dt.column);
            detailItemIndex++;
          }
        }
      }
      state.selectedHotspot = hotspot;
    },
    updateSelectedHotspotLocation(state, location) {
        state.selectedHotspot.location = location
    },
    setHotspotsData(state, hotspotsData) {
        let newGridRows = [];
        let curFunc = null;
        let colDef = null;

        let linkColumn = hotspotsData.linkcolumn;
        let ctaColumn = hotspotsData.ctacolumn;

        colDef = hotspotsData.columns;
        let rowIndex = 0;
        for (let hsi in hotspotsData.hotspots) {
            let hs = hotspotsData.hotspots[hsi];
            for (var fi in hs.func) {
                curFunc = hs.func[fi];
                let values = [];
                for (let ovi in curFunc.overview) {
                    let inf = curFunc.overview[ovi]
                    values.push({
                        key: curFunc.id,
                        column: inf.column,
                        value: inf.value,
                        context: inf.context,
                        icon: inf.icon,
                        purpose: inf.purpose
                    });
                }
                if(linkColumn != -1) {
                    values.splice(linkColumn, 0, {
                        key: curFunc.id,
                        column: curFunc.booklink == 0 ? "_assy" : "_ecat",
                        value: curFunc.link == -1 ? "" : curFunc.link
                    });
                }
                if(ctaColumn != -1) {
                  values.splice(ctaColumn, 0, {
                      key: curFunc.id,
                      column: '_cta',
                      value: curFunc
                  });
                }
                newGridRows.push({
                    id: hs.id,
                    key: curFunc.id,
                    twin: hs.twin,
                    link: curFunc.link,
                    booklink: curFunc.booklink,
                    values: values,
                    index: rowIndex++
                });
            }
        }
        let newCols = []
        if (curFunc != null) {
            for (let cfii in curFunc.overview) {
                let cinf = curFunc.overview[cfii]
                let displayName = colDef !== null && colDef.hasOwnProperty(cinf.column) ? colDef[cinf.column] : cinf.column
                newCols.push({key: cinf.column, displayName: displayName})
            }
        }

        if(linkColumn != -1) {
          newCols.splice(linkColumn, 0, {key: "_link", displayName: ""});
        }
        state.gridColumns = newCols;
        state.gridRows = newGridRows;
        state.hotspotsData = hotspotsData;
        state.hotspotFuncs = hotspotsData.hotspots.map(x => ({hotspotId: x.id, ...x.func[0]}));
    },
    setDrawerOpen(state, isOpen) {
        state.drawerOpen = isOpen;
    },




}

export default {
    state,
    getters,
    actions,
    mutations
}

function getParameterByName(name) {
    let url = window.location.href
    name = name.replace(/[[]]/g, '\\$&')
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

function stopThumbnailLoading() {
  let t = document.querySelectorAll(".main-view-wrapper img");
  if(t.length > state.uxd.thumbnailThreshold)
    t.forEach(r => { r.setAttribute("src", ""); });
}

function postToParentWindow(msg) {
  let protocol = getParameterByName('protocol');
  if (protocol === null) protocol = window.location.protocol;
  let host = getParameterByName('host');
  if(host == null) return;
  let port = getParameterByName('port') ?? '';
  let origin = protocol + '//' + host + (port !== '' ? ':' + port : '');
  window.parent.postMessage(msg, origin);
}

async function loadDrawingTreeByPartId(partId) {
  let part = state.parts.find(x => x.id == partId && x.type == "project");
  if(part == null) return;
  let result = await dao.getDrawingTreeByPartIdOrProjectId(state.selectedLocale, partId, part.data.id);
  let drawings = result.tree;
  MergeDrawingTreeToPubTree(drawings, partId, result.extlinks);
}

async function loadDrawingTreeByDrawingId(drawingId) {
  let result = await dao.getDrawingTreeByDrawingId(state.selectedLocale, drawingId);
  let drawings = result.tree;
  MergeDrawingTreeToPubTree(drawings, result.hook, result.extlinks);
}

async function loadDrawingTreeByDrawingName(drawingName, caseSens, fuzzy) {
  let result = await dao.getDrawingTreeByDrawingName(state.selectedLocale, drawingName, caseSens, fuzzy);
  let drawings = result.tree;
  MergeDrawingTreeToPubTree(drawings, result.hook, result.extlinks);
}


function MergeDrawingTreeToPubTree(drawings, partId, extLinks) {

  let part = state.parts.find(x => x.id == partId && x.type == "project");
  if(part == null) return;

  let singleRoot = drawings.filter(x => x.parent == -1).length < 2;
  drawings.forEach(d => {
    d.thumbUrl = dao.BASE_URL + 'getThumbnail.php?token=' + dao.TOKEN + '&id=drw' + d.id + '&size=full';
    d.rasterUrl = dao.BASE_URL + 'getRaster.php?token=' + dao.TOKEN + '&id=' + d.id;
    d.childCount = drawings.filter(x => x.parent == d.id).length;
    d.hasChildren = d.childCount > 0;
    d.isExpanded = d.parent == -1 && singleRoot;
    d.partIndex = part.partIndex;
    state.drawingMap[d.id] = d;
  });
  part.data.drawings = drawings;
  part.data.extlinks = extLinks;
}

function invokeMailClient(to,cc,subj,body) {
  let encodedBody = encodeURIComponent(body);
  let mailTo = "mailto:" + to + "?";
  if(cc != "") mailTo += "cc=" + cc + "&";
  mailTo += "subject=" + subj + "&body=";
  if (mailTo.length + encodedBody.length > 1995) {
    copyToClipboard(body);
    encodedBody = encodeURIComponent("** Please press Ctrl-A Ctrl-V    OR Right-Click and Paste the body template for this email **\n");
  }
  window.open(mailTo + encodedBody);
}

function copyToClipboard(str) {
  let el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

function URLWrap(obj) {
  return btoa(JSON.stringify(obj)).replace('=', '|').replace('/', '_').replace('+', '-');
}

function replaceCookiePlaceholder(url) {
  while (url.includes('{cookie:')) {
    let p1 = url.indexOf('{cookie:')
    let p2 = url.indexOf('}', p1);
    if(p2 > p1 && p1 > -1) {
      let name = url.substr(p1 + 8, p2 - p1 - 8);
      let value = window.sessionStorage.getItem('uc_' + name) ?? '';
      url = url.substr(0, p1) + value + url.substr(p2 + 1);
    } else {
      break;
    }
  }
  return url;
}
